export default {
  actionButton: 'سجّل اهتمامك لنتصل بك',
  registerButton: 'يسجل',

  palmWelcomeHeadingOne: '声明',
  palmWelcomeHeadingTwo: 'بيان حي',
  palmWelcomeHeadingThree: 'في جزيرة السعديات',
  palmWelcomeContent:
    'يعد ممشا بالم مسكنًا مبدعًا مستوحى من الطراز الياباني، صممه المهندس المعماري المشهور عالميًا كويتشي تاكادا، وهو منزل يميز نفسه على الفور.',

  palmStoryHeading:
    'سيتم الكشف عن الحياة الفاخرة والهادئة في جزيرة السعديات قريبًا',
  palmStoryContent:
    'تم تصميم كل عنصر من عناصر ممشى النخلة ليربط بين الطبيعة والهندسة المعمارية، ويعكس الفخامة الهادئة - بدءًا من الردهة الكبيرة وغرفة الشاي الهادئة وحتى موقعه الذي يحسد عليه في قلب المنطقة الثقافية في السعديات.',
  palmStoryExplore: 'استكشف المنطقة',

  palmRegistrationHeading: 'كن أول من يعرف المزيد',
  palmRegistrationContent:
    'قم بالتسجيل للتحدث مع مديري المبيعات المخصصين لدينا حول ممشى النخلة، واحصل على إرشادات حول تأمين عقار أحلامك.',

  firstName: 'الاسم',
  lastName: 'الكنية',
  email: 'البريد الإلكتروني',
  phoneNumber: 'رقم الهاتف',
  reasonToBuy: 'سبب الشراء',
  nationality: 'الجنسية',
  residencyStatus: 'حالة الإقامة',
  reasonBuyOptionInvestor: 'استثمار',
  reasonBuyOptionHomeOwner: 'سكن',
  recieveUpdates:
    'نعم، أودّ الحصول على قائمة العقارات الفاخرة المعروضة للبيع، كما أنني مهتم بالحصول على نصائح احترافية شخصية ومعرفة أحدث تطورات السوق العقاري.',
  consentLabel: 'أوافق على',
  privacyPolicy: 'سياسة الخصوصية',
  termsAndConditions: 'شروط الاستخدام',
  consentLabelEnd: 'من الدار',
  footerContactTitle: 'تواصل معنا:',
  launchFooterContactTitle: 'نرحب بكم،',
  footerContactCallText: 'اتصل على',
  footerContactCallNumber: '800 ALDAR',
  footerContactNumber: '+971 2 810 6400',
  footerContactWebsite: 'Aldar.com',
  developedBy: 'تطوير شركة الدار العقارية',
  successHeading: 'شكراً عل تسجيل اشتراكك',
  successContent:
    'يتطلع فريق مدراء مبيعاتنا للتواصل معك. ترقب رسائلنا في صندوق بريدك الإلكتروني للاطلاع على أخر التحديثات الحصرية. وإذا كنت مهتماً بمعرفة المزيد عن عروض الدار، اكتشف مرافقنا الأخرى ذات الطراز العالمي في قلب المنطقة الثقافية بجزيرة السعديات',
  successButton: 'اكتشف المزيد من المجتمعات',

  PalmFooterContact: 'اتصل بنا:',
  PalmFooterCall: 'اتصل على 800 الدار',
  PalmFooterPhone: '+971 2 810 6400',
  PalmFooterDeveloped: 'تم تطويره بواسطة الدار العقارية',

  launchPalmWelcomeHead: 'A LIVING STATEMENT',
  launchPalmWelcomeContent:
    'LIVE IN A ONE-OF-A-KIND RESIDENCE, CRAFTED FOR REFINED BEAUTY',
  launchPalmIntroHeadOne: 'INTRODUCING',
  launchPalmIntroHeadTwo: 'AN ICONIC RESIDENCE',
  launchPalmIntroContent:
    'A Japanese-inspired residence, Mamsha Palm is an architectural icon designed to mimic nature.',
  launchPalmDesignerHeadOne: 'DESIGNED BY',
  launchPalmDesignerHeadTwo: 'KOICHI TAKADA',
  launchPalmDesignerContent:
    'In collaboration with world-renowned architect Koichi Takada, Mamsha Palm is an iconic design that brings nature back into urban environments.',
  launchPalmHarmonyTakeTour: 'Take a Virtual Walk',
  launchPalmHarmonyHeadOne: 'EMBRACING ',
  launchPalmHarmonyHeadTwo: 'NATURE’S HARMONY',
  launchPalmHarmonyContent:
    'Biophilic design weaves throughout Mamsha Palm, inspired by the protective canopy of palm trees that cools their surroundings.',
  launchPalmApartmentsHead: '44 EXCLUSIVE APARTMENTS',
  launchPalmApartmentsContent:
    "Be one of 44 in the world to own a residence or sky villa with spacious layouts that maximise breathtaking views of Guggenheim Abu Dhabi. Close to the heart of Saadiyat Island, it's closer to the beach, shopping, and dining.",

  launchTabAmenity: 'سجّل الآن',
  launchTabSustain: 'سجّل الآن',
  launchTabLocation: 'سجّل الآن',

  launchPalmAmenitiesHead: 'UNMATCHED ELEGANCE AND CONVENIENCE ',
  launchPalmAmenitiesContent:
    'Exclusive amenities designed to elevate your lifestyle. Every serene space combines to weave natural harmony into every moment of life.',

  launchPalmSustainabilityHead: 'CRAFTED FOR SUSTAINABILITY',
  launchPalmSustainabilityContent:
    'Inspired by the natural environment and designed to preserve it, through a series of innovative green technologies and processes.',

  launchPalmLocationHead: 'ON THE MOST FAVOURED ISLAND',
  launchPalmLocationContent:
    'Saadiyat Island seamlessly blends natural beauty and cultural richness, as world-class beaches lie just minutes from globally renowned museums.',

  launchPalmExclusivityHeadOne: 'DETAILS THAT',
  launchPalmExclusivityHeadTwo: 'DEFINE EXCLUSIVITY',
  launchPalmExclusivityContent:
    'Every interior space has been crafted to reflect the refined beauty of Koichi Takada’s architectural concept; materials and finishes all contributing to an elevated way of life.',
};
